// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nx-0";